import React from 'react';
import styled from 'styled-components';

import useScreenQuery from '../../../hooks/useScreenQuery';
import PlayupThemeProvider from '../../../themes/PlayupThemeProvider';
import { BodyContainer, PageContainer } from '../sharedStyles';
import { TitleHeader } from '../sharedStyledComponents';

const PortalSelfExclusion = () => {
	const { isSmall } = useScreenQuery();
	const [lifetimeExclusionSelected, setLifetimeExclusionSelected] = React.useState(true);

	return (
		<PlayupThemeProvider>
			{isSmall && <TitleHeader title={'Self Exclusion'} />}
			<PageContainer isSmallScreen={isSmall}>
				<ExclusionSelection isSmallScreen={isSmall}>
					<ExclusionSelectionButton
						selected={lifetimeExclusionSelected}
						onClick={() => setLifetimeExclusionSelected(true)}
					>
						Lifetime Exclusion
					</ExclusionSelectionButton>
					<ExclusionSelectionButton
						selected={!lifetimeExclusionSelected}
						onClick={() => setLifetimeExclusionSelected(false)}
					>
						BetStop - Self-Exclusion Register
					</ExclusionSelectionButton>
				</ExclusionSelection>
				<BodyContainer isSmallScreen={isSmall}>
					{lifetimeExclusionSelected && (
						<>
							<Paragraph isSmallScreen={isSmall}>
								If you feel you are having issues managing your gambling behaviour, you may temporarily or permanently
								exclude from gambling with us and other northern territory registered bookmakers by submitting a
								self-exclusion notice.
							</Paragraph>
							<Paragraph isSmallScreen={isSmall}>
								Once you submit your notice for self-exclusion, you will not be able to edit or remove it. During the
								self-exclusion period you will not be able to access or login to your account. Any bets that have not
								resulted will remain pending and you will only be able to withdraw your balance by contacting customer
								service.
							</Paragraph>
							<Paragraph isSmallScreen={isSmall}>
								<Link
									href="https://nt.gov.au/industry/gambling/gambling/self-exclusion-from-a-sports-bookmaker-or-betting-exchange-operator"
									target="_blank"
									rel="noreferrer"
									className="_text-secondary"
								>
									Click here
								</Link>{' '}
								for further information.
							</Paragraph>
						</>
					)}
					{!lifetimeExclusionSelected && (
						<>
							<Paragraph isSmallScreen={isSmall}>
								<Link href="https://www.betstop.gov.au/" target="_blank" rel="noreferrer" className="_text-secondary">
									BetStop – the National Self-Exclusion Register
								</Link>{' '}
								is a free service for people who want help changing their gambling habits.
							</Paragraph>
							<Paragraph isSmallScreen={isSmall}>
								It allows people to self-exclude from all legal online or phone wagering operations in Australia in one
								simple process.
							</Paragraph>
							<Paragraph isSmallScreen={isSmall}>
								Once someone has chosen their self-exclusion period, these wagering providers are not allowed to accept
								a bet or open a new account for them. Providers are also not allowed to send direct marketing messages
								to people who have self-excluded.
							</Paragraph>
							<Paragraph isSmallScreen={isSmall}>
								People who have registered will be able to nominate up to 5 support people to help them manage their
								self‑exclusion. Personal details of users will be protected.
							</Paragraph>
						</>
					)}
				</BodyContainer>
			</PageContainer>
		</PlayupThemeProvider>
	);
};

export default PortalSelfExclusion;

const Paragraph = styled.p<{ isSmallScreen: boolean }>`
	color: ${({ theme }) => theme.colors.darkR};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
	margin-bottom: 20px;
	line-height: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '26px')};
`;

const Link = styled.a`
	text-decoration: underline;
	color: ${({ theme }) => theme.colors.blue};
	font-weight: 600;

	&:hover {
		color: ${({ theme }) => theme.colors.info};
	}
`;

export const ExclusionSelection = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 55px;
	color: ${({ theme }) => theme.colors.white};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '20px')};
`;

export const ExclusionSelectionButton = styled.button<{ selected: boolean }>`
	flex: 1;
	margin: 0;
	background-color: ${({ theme, selected }) => (selected ? theme.colors.darkGreyR : theme.colors.darkR)};
	cursor: pointer;
	border: none;

	&:focus {
		outline: none;
	}

	&:hover {
		opacity: 0.8;
	}
`;
